<template>
    <section-con main="18年好未来教学方法沉淀" sub="科学的教学，让老师更加得心应手">
       <div class="teach-method">
           <div class="teach-method-item" v-for="(item, index) in list" :key="index">
               <div class="title-box">
                   <p class="title">{{item.title}}</p>
               </div>
               <img class="content-img" :class="`img${index + 1}`" :src="item.content">
           </div>
       </div>
    </section-con>
</template>
<script>
export default {
    data () {
        return {
            list: [
                {
                    title: '6大教学模式',
                    content: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-2-1.png'
                },
                {
                    title: '7步备课法',
                    content: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-2-2.png'
                },
                {
                    title: '8步教学法',
                    content: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-2-3.png'
                }
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
.teach-method{
    padding: 0px 20px;
    .teach-method-item{
        margin-bottom: 40px;
        .title-box{
            width: 221px;
            height: 0px;
            border: 0px;
            border-top: 2px dotted #D8D8D8;
            position: relative;
            margin: 0 auto;
            .title{
                font-size:14px;
                font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:#282828;
                line-height:20px;
                background: #ffffff;
                padding: 0px 10px;
                position: absolute;
                top: -9px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        .content-img{
            width: 100%;
            margin-top: 30px;
            &.img1{
                width: 297px;
            }
        }
        &:last-of-type{
            margin-bottom: 0px;
        }
    }
}
</style>